import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import {
    PlayerModalDataSelector,
    playerModalSelector
} from 'store/modules/brownlow-tracker/player-modal/selectors';
import FocusTrap from 'focus-trap-react';
import { SvgIcon } from 'common/react/components/SvgIcon';
import { getTranslation } from 'common/react/utils/translations';
import {
    FETCH_PLAYER_MODAL_DATA,
    UPDATE_PLAYER_MODAL
} from 'store/modules/brownlow-tracker/player-modal/actions';
import { PlayerModalRoundByRound } from './player-modal-round-by-round';
import { PlayerModalDetails } from './player-modal-details';
import { PlayerModalPhoto } from './player-modal-photo';

export const PlayerModal = () => {
    const dispatch = useDispatch();
    const modal = useSelector(playerModalSelector);
    const isVisible = modal.visible;
    const data = useSelector(PlayerModalDataSelector);

    const closeModal = () => {
        dispatch(
            UPDATE_PLAYER_MODAL.request({
                visible: false
            })
        );
    };

    useEffect(() => {
        // Handle esc key
        const handleEsc = (event) => {
            if (event.keyCode === PULSE.app.common.CONSTANTS.KEY_CODES.ESCAPE) {
                closeModal();
            }
        };
        window.addEventListener('keydown', handleEsc);

        return () => {
            window.removeEventListener('keydown', handleEsc);
        };
    }, []);

    useEffect(() => {
        if (modal.seasonPid && (!data || data.seasonPid !== modal.seasonPid)) {
            dispatch(
                FETCH_PLAYER_MODAL_DATA.request({
                    seasonPid: modal.seasonPid
                })
            );
        }
    }, [modal.seasonPid]);

    return (
        <>
            {isVisible && (
                <div className="brownlow-player-modal">
                    <div
                        className="brownlow-player-modal__overlay"
                        onClick={() => closeModal()}
                    ></div>
                    <FocusTrap
                        focusTrapOptions={{
                            initialFocus: false,
                            clickOutsideDeactivates: true
                        }}
                    >
                        <div className="brownlow-player-modal__container">
                            <button
                                data-modal-action="close"
                                className="brownlow-player-modal__modal-close"
                                onClick={() => closeModal()}
                            >
                                <SvgIcon
                                    icon="close"
                                    className="brownlow-player-modal__modal-close-icon"
                                />
                                <span className="u-screen-reader">
                                    {getTranslation('label.close')}
                                </span>
                            </button>

                            <div className="brownlow-player-modal__header">
                                <div className="brownlow-player-modal__background-container">
                                    <div className="brownlow-player-modal__background"></div>
                                    <div className="brownlow-player-modal__watermark"></div>
                                </div>
                                <PlayerModalDetails
                                    seasonPid={modal.seasonPid}
                                    playerId={modal.playerId}
                                />
                                <PlayerModalPhoto />
                            </div>

                            <PlayerModalRoundByRound />
                        </div>
                    </FocusTrap>
                </div>
            )}
        </>
    );
};
